import { User, FileText, CheckSquare, FileCheck, Car, Home, Building2, Heart, Umbrella, Plane, ListTodo } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { WorkflowCard } from "./workflow/WorkflowCard";

const workflowSteps = [
  {
    icon: User,
    title: "Get a Free Quote",
    description: "Request a quote in minutes and customize your coverage to meet your specific needs.",
    stats: {
      label: "Happy Clients",
      value: "2000+"
    }
  },
  {
    icon: FileText,
    title: "Choose Your Coverage",
    description: "Select from our comprehensive range of insurance products tailored for your needs.",
    insuranceTypes: [
      { name: "Auto", icon: Car },
      { name: "Home", icon: Home },
      { name: "Business", icon: Building2 },
      { name: "Life", icon: Heart },
      { name: "Umbrella", icon: Umbrella },
      { name: "Travel", icon: Plane }
    ]
  },
  {
    icon: CheckSquare,
    title: "Review & Approve",
    description: "Review your policy details and approve the coverage that best fits your situation.",
    pricing: {
      premium: "$159/mo",
      coverage: "$500,000",
      periods: ["Monthly", "Quarterly", "Yearly"]
    }
  },
  {
    icon: FileCheck,
    title: "Get Insured",
    description: "Complete your application and receive your policy documents instantly.",
    update: "Policy Overview Updated weekly"
  }
];

const Workflow = () => {
  return (
    <section className="py-12 sm:py-16 sm:my-16 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-8 sm:mb-12">
          <Badge variant="secondary" className="bg-[#F8F7FF] text-primary text-sm mb-3 sm:mb-4 flex items-center gap-1 mx-auto w-fit">
            <ListTodo className="h-4 w-4" />
            Workflow
          </Badge>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4 px-2">
            How our agency makes your insurance{" "}
            <span className="text-primary">simpler</span>
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {workflowSteps.map((step, index) => (
            <WorkflowCard
              key={index}
              {...step}
              index={index}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Workflow;
